import { cn } from "@/lib/utils";
import { ReactNode, forwardRef } from "react";
import { ButtonProps, Button as AriaButton } from "react-aria-components";

type Props = ButtonProps & {
  children?: ReactNode;
  isPending?: boolean;
  uploadPercent?: number | null;
  variant?: "primary" | "secondary" | "tertiary";
};

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      variant = "primary",
      children,
      isPending,
      uploadPercent = null,
      className = "",
      ...props
    },
    ref,
  ) => {
    let style =
      variant === "primary"
        ? "bg-primary text-white"
        : variant === "secondary"
        ? "bg-secondary text-white"
        : "bg-white text-black";

    return (
      <AriaButton
        className={cn(
          `flex h-[60px] w-full items-center justify-center rounded-full bg-primary p-5 text-lg font-semibold uppercase`,
          style,
          className,
        )}
        ref={ref}
        disabled={isPending}
        {...props}
      >
        {isPending && (
          <>
            <div className="mr-2 h-[25px] w-[25px] animate-spin rounded-full border-4 border-red-500 border-t-red-100" />
            {uploadPercent != null && <span className="mr-2">{uploadPercent}%</span>}
          </>
        )}
        {children}
      </AriaButton>
    );
  },
);

Button.displayName = "Button";
export default Button;
